function EntityStatusPicker({
  value,
  options,
  name = 'status',
  onChange,
  error,
  label = 'Status',
}) {
  return (
    <div className="grid gap-2">
      <span className="text-[0.88rem] font-medium text-[var(--theme-text-subtle)]">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isActive = option === value;

          return (
            <button
              key={option}
              className={`rounded-full border px-4 py-2 text-[0.9rem] font-medium transition ${
                isActive
                  ? 'border-[var(--theme-accent-strong)] bg-[var(--theme-accent)] text-white shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.2)]'
                  : 'border-[var(--theme-border)] bg-[var(--theme-surface-soft)] text-[var(--theme-text-subtle)] hover:border-[var(--theme-accent)] hover:bg-[var(--theme-accent-soft)] hover:text-[var(--theme-accent-strong)]'
              }`}
              type="button"
              onClick={() =>
                onChange({
                  target: {
                    name,
                    value: option,
                  },
                })
              }
              aria-pressed={isActive}
            >
              {option}
            </button>
          );
        })}
      </div>
      {error ? <span className="text-[0.82rem] text-[#bb5745]">{error}</span> : null}
    </div>
  );
}

export default EntityStatusPicker;
